import { PricingModel } from 'src/graphql/generated';
import { TealiumPricingType } from 'src/types/tealium';

export const getPricingType = (pricingModel: string | undefined) => {
  if (!pricingModel) {
    return TealiumPricingType.Variable;
  }
  return pricingModel === PricingModel.HORIZON
    ? TealiumPricingType.Variable
    : TealiumPricingType.Fixed;
};
